export const SUPPORT_TOPICS = {
  LOGBOOK: {
    code: 'suptop_logbook',
    label: 'Logbook',
  },
  DIARY: {
    code: 'suptop_diary',
    label: 'Diary',
  },
  NOTES: {
    code: 'suptop_notes',
    label: 'Notes',
  },
  REGISTRATION: {
    code: 'suptop_login',
    label: 'Registration',
  },
  PUBLIC_AREA: {
    code: 'suptop_publicarea',
    label: 'Public area',
  },
  TWO_FACTOR: {
    code: 'suptop_2nd_factor',
    label: '2. Faktor',
  },
  APPOINTMENTS: {
    code: 'suptop_appointments',
    label: 'Appointments',
  },
  QUESTIONNAIRES: {
    code: 'suptop_questionnaire',
    label: 'Questionnaires',
  },
  MESSAGES: {
    code: 'suptop_messages',
    label: 'Messages',
  },
  MESSAGESPROVIDER: {
    code: 'suptop_messages',
    label: 'Messages',
  },
  DOCUMENTS: {
    code: 'suptop_files',
    label: 'Documents',
  },
  PROFILE: {
    code: 'suptop_profile',
    label: 'Profile',
  },
  DASHBOARD: {
    code: 'suptop_dashboard',
    label: 'Dashboard',
  },
  PRIVACY_COCKPIT: {
    code: 'suptop_access',
    label: 'Privacy Cockpit',
  },
  SUPPORT: {
    code: 'suptop_support',
    label: 'Support',
  },
  PATIENTS: {
    code: 'suptop_patilist',
    label: 'Patienten',
  },
  CONTEXT_DOCUMENTS: {
    //TODO: change to cms label once this is fixed
    code: 'suptop_documents_representative',
    label: 'Patienten',
  },
};
